module.exports = __webpack_public_path__ + "static/media/house.dbb09669.svg";